import { Button, Dialog, DialogContent, DialogTitle, DialogFooter, DialogHeader, DialogDescription, } from '@cargomatic/ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { showToast } from 'stores/ToastStore';
import { updatePreArrivalShipmentStatus } from 'utils/ShipmentWebAPIUtils';
const UpdatePrenoticeShipmentStatusModal = ({ orders, status, shipmentCount, onHide, open = false, }) => {
    const { t } = useTranslation();
    const toStatus = status === 'final' ? 'FINAL' : 'PRE_NOTICE';
    const fromStatus = toStatus === 'FINAL' ? 'PRE_NOTICE' : 'FINAL';
    const handleOnSubmit = async () => {
        try {
            await updatePreArrivalShipmentStatus({ orders, status });
            showToast('', t('UPDATE_SUCCESS'));
        }
        catch (e) {
            showToast('', e.message, 'error');
        }
        finally {
            onHide();
        }
    };
    return (React.createElement(Dialog, { open: open, onOpenChange: onHide, className: "z-50" },
        React.createElement(DialogContent, { className: "sm:max-w-[600px]" },
            React.createElement(DialogHeader, null,
                React.createElement(DialogTitle, null, t('UPDATE_PRENOTICE_STATUS_TITLE', {
                    from: t(fromStatus),
                    to: t(toStatus),
                })),
                React.createElement(DialogDescription, null, t('UPDATE_PRENOTICE_STATUS_DESCRIPTION', {
                    count: shipmentCount,
                    to: t(toStatus),
                }))),
            React.createElement(DialogFooter, null,
                React.createElement(Button, { className: "bg-transparent text-black", onClick: onHide }, t('CANCEL')),
                React.createElement(Button, { type: "submit", onClick: handleOnSubmit }, t('CONFIRM'))))));
};
export default UpdatePrenoticeShipmentStatusModal;
